// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { haqqMainnet as _haqqMainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the haqqMainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11235
 * Chain Name: HAQQ Mainnet
 * Default Block Explorer: https://explorer.haqq.network
 * Default RPC URL: https://rpc.eth.haqq.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { haqqMainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: haqqMainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const haqqMainnet = createCommon({
	..._haqqMainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
